import React from 'react';
import styled from 'styled-components';
import { TextField as LoginMUITextField } from '@material-ui/core';

const TextField = styled(props => <LoginMUITextField fullWidth {...props} />)`

  & .MuiInputBase-multiline {
    box-shadow: none;
    height: 100px;
  }

  & .MuiInputBase-formControl {
    margin-top: 0;
    & input { // overrides scss styling that gives certain inputs a green bottom-border
      border-bottom: none !important;
    }
  }

  & .MuiInputBase-input {
    font-family: 'Assistant', sans-serif;
  }

`;

export default TextField;

